import React from 'react';
import styles from './stats.module.css';
import { SERIES_COLORS } from './palette';

/** Degradê claro da cor (hex de 6 dígitos): barra grossa sem pesar. */
const softBar = (color) => `linear-gradient(90deg, ${color}59, ${color}B3)`;

/**
 * Ranking com barra proporcional ao maior item.
 * `items`: [{ label, value, display?, sub? }]; `color`: cor única das barras
 * (sem ela, cada linha usa uma cor da sequência).
 */
const RankList = ({ items, color, limit = 8, empty = 'Nada no período.' }) => {
  const list = (items || []).slice(0, limit);
  if (list.length === 0) return <div className={styles.emptyChart}>{empty}</div>;
  const max = Math.max(...list.map((item) => Number(item.value) || 0), 1);

  return (
    <div className={styles.rank}>
      {list.map((item, index) => (
        <div key={`${item.label}-${index}`} className={styles.rankItem}>
          <div className={styles.rankHead}>
            <span className={styles.rankLabel} title={item.label}>{item.label}</span>
            <span className={styles.rankValue}>
              {item.display ?? item.value}
              {item.sub && <span className={styles.rankSub}>{item.sub}</span>}
            </span>
          </div>
          <div className={styles.rankTrack}>
            <div
              className={styles.rankBar}
              style={{
                width: `${Math.max(((Number(item.value) || 0) / max) * 100, 2)}%`,
                background: softBar(color || SERIES_COLORS[index % SERIES_COLORS.length]),
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default RankList;
